module.exports = __webpack_public_path__ + "static/products-89064ef85172ea4bd291661451b09324.jpg";